import { Box, Button, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useMemo } from 'react'; 
import { useLocation, useNavigate } from 'react-router-dom'; 

import { useAuthContext } from '../../../context';
import { SubNivelAcesso } from '../../../services/api/users/UserServices';

interface IVMEmergencyPlanProps {
    id: string;
}

export const VMEmergencyPlan: React.FC<IVMEmergencyPlanProps> = ({ id }) => {
    const navigate = useNavigate();
    const location = useLocation(); 
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    const { userData } = useAuthContext();

    const paePermissoes: SubNivelAcesso = useMemo(() => {
        return userData?.nivel_acesso?.PAE || {};
    }, [userData]); 

    const isButtonActive = (path: string) => {
        return location.pathname === path;
    };

    const hasPermission = (permissionValue: string | null | undefined): boolean => {
        return typeof permissionValue === 'string' && permissionValue !== '';
    };

    return (
        <Box
            display={'flex'}
            flexDirection={smDown ? 'column' : 'row'}
            width={'100%'}
        >
            <Box
                display={'flex'}
                flexDirection={'column'}
                alignItems={smDown ? 'center' : 'start'}
                width={smDown ? '100%' : '50%'}
                padding={1}
            >
                <Typography variant='h6' color={theme.palette.primary.main} marginLeft={1}>Registros Legais</Typography> 

                {/* {hasPermission(paePermissoes.aco) && ( 
                    <Button variant={isButtonActive(`/information_dam/${id}/aco`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/aco`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>ACO</Typography>
                    </Button>
                )} */}

                {hasPermission(paePermissoes.PAE) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/emergency_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/emergency_plan`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Plano de ação de Emergência</Typography>
                    </Button>
                )}

                {hasPermission(paePermissoes.conformidades) && ( 
                    <Button variant={isButtonActive(`/information_dam/${id}/aco`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/aco`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Avaliação de Conformidade e Operacionalidade</Typography>
                    </Button>
                )}

                {hasPermission(paePermissoes.treinamento) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/semiannual_internal_training`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/semiannual_internal_training`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Treinamento Interno Semestral</Typography>
                    </Button>
                )}

                {hasPermission(paePermissoes.seminario) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/annual_guidance_seminar`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/annual_guidance_seminar`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Seminário Orientativo Anual</Typography>
                    </Button>
                )}

                {hasPermission(paePermissoes.simulado) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/emergency_situation_simulation`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/emergency_situation_simulation`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Simulado de Situação de Emergência</Typography>
                    </Button>
                )}

                {hasPermission(paePermissoes.registro) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/emergency_situation_register`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/emergency_situation_register`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Registro de Situação de Emergências</Typography>
                    </Button>
                )}
            </Box>
            <Divider orientation={smDown ? 'horizontal' : 'vertical'} flexItem variant="fullWidth" />
            <Box
                display={'flex'}
                flexDirection={'column'}
                alignItems={smDown ? 'center' : 'start'}
                width={smDown ? '100%' : '50%'}
                padding={1}
            >
            </Box>
        </Box>
    );
};